import { DelMainCategoryMutation, ListMainCategoryQuery } from "../generated/graphql";
import { useListMainCategory } from "../hooks/useListMainCategory";
import { useEffect } from "react";
import { AsideAdminComponent } from "../layout/aside-admin";
import { ComponentTabLink, ITabLink, ITabTitle, PageType } from "../components/component-tab";
import { TableError } from "../components/table-error";
import { useState } from "react";
import { pageIndicator } from "../apollo";
import { useNavigate } from "react-router-dom";
import { useDelMainCategory } from "../hooks/useDelMainCategory";


export const AdminListMainCategory = () => {
    const navigate = useNavigate();
    const tabList: ITabLink[] = [
        { text: "카테고리", to: "/category", selected: true },
        { text: "거래처", to: "/corporation" },
        { text: "서비스", to: "/service" },
      ];

  const stitle: ITabTitle = { text: "카테고리" };

  const onCompleted = (data: ListMainCategoryQuery) => {
    
  };
  const [listMainCategory, { loading: listMainCategoryLoading, data }] =
    useListMainCategory(onCompleted);

  const onDelCompleted = (data: DelMainCategoryMutation) => {
    if (data.delMainCategory.ok) {
      alert("카테고리 삭제");
      window.location.reload();
    } else {
      alert(data.delMainCategory.err);
    }
  };
  const [delMainCategory, { loading: delMainCategoryLoading }] =
    useDelMainCategory(onDelCompleted);

  const delMainCategoryHandler = (id: number) => {
    if (window.confirm("삭제한 카테고리는 복구할 수 없습니다. 정말로 삭제하시겠습니까?")) {
      delMainCategory({ variables: { input: { id } } });
    }
  };
  useEffect(() => {
    pageIndicator("corporation");
    listMainCategory();
  }, [listMainCategory]);


  return (
    <div className="bg-main bg-opacity-50 w-full h-full min-h-screen">
      <div className="w-full mx-auto h-full min-h-screen bg-gray-100">
        <main id="main">
          <div className="grid grid-cols-[200px_1fr] max-w-full">
            <AsideAdminComponent />
            <div className="mypages bg-gray-100 w-full min-w-[1200px] overflow-hidden">
              <div className="orderWrap">
                <div className="h-fix-content relative">
                  <div className={`w-full h-full px-10 py-8`}>
                    <ComponentTabLink
                      tabs={tabList}
                      stitle={stitle}
                      type={PageType.MainCategory}
                      setSearchs={() => {}}
                    />
                    {/* 목록 */}
                    <div className=" shadow-lg h-[800px] h-fix-content w-full overflow-auto bg-white">
                      <table
                        className="align-center w-[1623px] text-sm "
                        id="table"
                      >
                        <colgroup>
                          <col width="36" />
                          <col />
                          <col width="160" />
                          <col width="160" />
                       
                        </colgroup>
                        <thead>
                          <tr className="border-b border-[#F9F8F9] h-8">
                            <th className="text-[#8B8C8C] ">no</th>
                            <th className="text-[#8B8C8C] ">이름</th>
                            <th className="text-[#8B8C8C] ">이미지</th>
                            <th className="text-[#8B8C8C] ">기능</th>
                          </tr>
                        </thead>
                        <tbody>
                          {!listMainCategoryLoading && data?.listMainCategory.mainCategories && data.listMainCategory.mainCategories.map((mainCategory, index) => (
                          <tr className="border-b border-[#F9F8F9] h-[68px]" key={`category-${mainCategory.id}`}>
                            <td className="table-text">{index + 1}</td>
                            <td className="table-text">{mainCategory.name}</td>
                            <td className="table-text flex p-1 justify-center items-center">
                              <img className="w-24 h-24 " src={mainCategory.upload?.url || ""} alt="썸네일" />
                            </td>
                            <td className="table-text justify-center items-center py-4 ">
                                <div className="flex items-center justify-center gap-2">
                              <button onClick={() => {
                                navigate(`/category/edit/${mainCategory.id}`);
                              }} className="bg-black text-white px-4 py-2 rounded-md">수정</button>
                              <button onClick={() => {
                                delMainCategoryHandler(mainCategory.id);
                              }} className="bg-black text-white px-4 py-2 rounded-md">삭제</button>
                              </div>
                            </td>
                          </tr>
                        ))}
                        </tbody>
                      </table>
                      {listMainCategoryLoading && (
                        <TableError errorMessage={`정보를 불러오는중입니다`} />
                      )}
                      {!listMainCategoryLoading &&
                        data?.listMainCategory.mainCategories &&
                        data.listMainCategory.mainCategories.length < 1 && (
                          <TableError errorMessage={`카테고리 정보가 없습니다`} />
                        )}
              
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};